import React from 'react'
import ApolloClient from 'apollo-boost'
import { useAuth0 } from '../contexts/Auth0Context'
import { ApolloProvider } from '@apollo/react-hooks'
import * as Sentry from '@sentry/browser'

const AuthorizedApolloClient = ({ children }) => {
  const { getIdTokenClaims, user } = useAuth0()

  const apolloClient = new ApolloClient({
    uri: `${process.env.REACT_APP_V3_ENDPOINT}/graphql`,
    request: async (operation) => {
      const token = await getIdTokenClaims()
      operation.setContext({
        headers: {
          auth: token ? `Bearer ${token.__raw}` : '',
        },
      })
    },
    onError: ({ graphQLErrors, networkError, response, operation }) => {
      if (graphQLErrors) {
        graphQLErrors.map(({ message }) => {
          const context = { variables: JSON.stringify(operation.variables), operationName: operation.operationName }
          return Sentry.withScope(function (scope) {
            scope.setUser({ legacyFreelancerId: user.legacyFreelancerId, email: user.email })
            Sentry.captureEvent({
              message: message,
              exception: {
                values: [{ type: 'GraphQLError', value: message }],
              },
              contexts: { context },
            })
          })
        })
      }

      if (networkError) {
        console.log(`[Network error]: ${networkError}`)
      }

      if (response) {
        console.log(`AuthorizedApolloClient -> JSON.stringify(response)`, JSON.stringify(response))
        response.errors = undefined
      }
    },
  })
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}

export default AuthorizedApolloClient
